import APIController from './APIController';
const AdminController = () =>{
    //Requesthelper
    const {basicRequest, jsonRequest} = APIController()

    const getAllUser= async () => {
        const data = await jsonRequest(`/user/all`);
        return data;
    };

    const updateUser = async(id, userAdminDTO) => {
        const data = await basicRequest(`/user/update_user/${id}`, "PUT", userAdminDTO);
        return data;
    }

    const giveAdmin = async (id) => {
        const data = await basicRequest(`/user/make_admin/${id}`, "PUT");
        return data;
    };

    const removeAdmin = async (id) => {
        const data = await basicRequest(`/user/make_user/${id}`, "PUT");
        return data;
    };

    const getAllWorkspaces = async () => {
        const data = await jsonRequest(`/workspace`);
        return data;
    };

    const updateWorkspace = async (id, workspaceAdminDTO) => {
        const data = await basicRequest(`/workspace/update_workspace/${id}`, "PUT", workspaceAdminDTO);
        return data;
    };

    const deactivateWorkspace = async (id) => {
        const data = await basicRequest(`/workspace/${id}`, "DELETE");
        return data;
    };

    const reactivateWorkspace = async (id) => {
        const data = await basicRequest(`/workspace/reactivate/${id}`, "PUT");
        return data;
    };

    const convertOrders = async(workspaceId) =>{
        const data = await basicRequest(`/${workspaceId}/order/convert_order_build`, "POST")
        return data
    }

    return {getAllUser, giveAdmin, removeAdmin, updateUser, updateWorkspace, getAllWorkspaces, deactivateWorkspace, reactivateWorkspace, convertOrders}
}
export default AdminController